var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDadosCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 154,
    viewBox: "0 0 244 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.392 143.642H46.895C43.867 143.642 41.413 141.188 41.413 138.16H205.873C205.874 141.188 203.419 143.642 200.392 143.642Z",
    fill: "#0073F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.392 144.642H46.895C43.321 144.642 40.413 141.735 40.413 138.161C40.413 137.608 40.861 137.161 41.413 137.161H205.873C206.425 137.161 206.873 137.608 206.873 138.161C206.874 141.734 203.966 144.642 200.392 144.642ZM42.525 139.16C42.981 141.151 44.767 142.641 46.895 142.641H200.392C202.52 142.641 204.306 141.151 204.762 139.16H42.525Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.958 138.16H55.329V60.1469C55.329 58.2839 56.839 56.7729 58.703 56.7729H188.585C190.448 56.7729 191.959 58.2829 191.959 60.1469V138.16H191.958Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.958 139.16H55.329C54.777 139.16 54.329 138.713 54.329 138.16V60.146C54.329 57.735 56.291 55.7729 58.703 55.7729H188.584C190.996 55.7729 192.958 57.735 192.958 60.146V138.16C192.958 138.713 192.51 139.16 191.958 139.16ZM56.329 137.16H190.957V60.146C190.957 58.837 189.892 57.7729 188.583 57.7729H58.703C57.394 57.7729 56.329 58.837 56.329 60.146V137.16Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.367 65.6289H62.919V133.522H184.367V65.6289Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.367 134.521H62.919C62.367 134.521 61.919 134.074 61.919 133.521V65.6289C61.919 65.0759 62.367 64.6289 62.919 64.6289H184.367C184.919 64.6289 185.367 65.0759 185.367 65.6289V133.522C185.367 134.074 184.919 134.521 184.367 134.521ZM63.919 132.521H183.367V66.6289H63.919V132.521Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.103 123.691H14.741C13.689 123.691 12.836 122.838 12.836 121.786V81.7541C12.836 80.7021 13.689 79.8491 14.741 79.8491H34.104C35.156 79.8491 36.009 80.7021 36.009 81.7541V121.786C36.008 122.838 35.155 123.691 34.103 123.691Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.103 124.691H14.741C13.139 124.691 11.836 123.387 11.836 121.786V81.7541C11.836 80.1521 13.139 78.8501 14.741 78.8501H34.103C35.705 78.8501 37.008 80.1531 37.008 81.7541V121.786C37.008 123.388 35.705 124.691 34.103 124.691ZM14.741 80.8501C14.242 80.8501 13.836 81.2551 13.836 81.7541V121.786C13.836 122.285 14.242 122.691 14.741 122.691H34.103C34.602 122.691 35.008 122.285 35.008 121.786V81.7541C35.008 81.2551 34.602 80.8501 34.103 80.8501H14.741Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.953 83.3071H15.891V120.869H32.953V83.3071Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.953 121.869H15.891C15.339 121.869 14.891 121.422 14.891 120.869V83.3081C14.891 82.7551 15.339 82.3081 15.891 82.3081H32.953C33.505 82.3081 33.953 82.7551 33.953 83.3081V120.87C33.953 121.422 33.505 121.869 32.953 121.869ZM16.891 119.869H31.953V84.3081H16.891V119.869Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.416 87.135L114.694 113.28H121.87L132.593 87.135H125.416Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.87 114.28H114.694C114.361 114.28 114.049 114.114 113.863 113.837C113.677 113.561 113.642 113.209 113.768 112.9L124.491 86.754C124.645 86.379 125.011 86.134 125.416 86.134H132.592C132.925 86.134 133.237 86.3 133.423 86.577C133.609 86.853 133.644 87.205 133.518 87.514L122.795 113.66C122.642 114.035 122.276 114.28 121.87 114.28ZM116.185 112.28H121.2L131.103 88.134H126.088L116.185 112.28Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.185 104.27H18.739C18.187 104.27 17.739 103.823 17.739 103.27C17.739 102.717 18.187 102.27 18.739 102.27H29.185C29.737 102.27 30.185 102.717 30.185 103.27C30.185 103.823 29.737 104.27 29.185 104.27Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.185 107.759H18.739C18.187 107.759 17.739 107.312 17.739 106.759C17.739 106.206 18.187 105.759 18.739 105.759H29.185C29.737 105.759 30.185 106.206 30.185 106.759C30.185 107.312 29.737 107.759 29.185 107.759Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.483 86.7959L18.739 98.3639H21.914L26.658 86.7959H23.483Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.914 99.3629H18.739C18.406 99.3629 18.094 99.1969 17.908 98.9199C17.722 98.6439 17.687 98.2919 17.813 97.9829L22.557 86.4159C22.711 86.0409 23.077 85.7959 23.482 85.7959H26.657C26.99 85.7959 27.302 85.9619 27.488 86.2389C27.674 86.5149 27.709 86.8669 27.583 87.1759L22.839 98.7429C22.686 99.1179 22.32 99.3629 21.914 99.3629ZM20.23 97.3629H21.243L25.167 87.7959H24.154L20.23 97.3629Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.267 133.398V141.032C47.267 147.356 42.14 152.483 35.816 152.483C29.492 152.483 24.365 147.356 24.365 141.032V125.763",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.815 153.484C28.949 153.484 23.364 147.898 23.364 141.032V125.763H25.364V141.032C25.364 146.796 30.052 151.484 35.815 151.484C41.578 151.484 46.267 146.796 46.267 141.032V133.398H48.267V141.032C48.267 147.898 42.681 153.484 35.815 153.484Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.364 133.398V113.358C24.364 111.777 25.646 110.495 27.227 110.495C28.808 110.495 30.09 111.777 30.09 113.358V133.398",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.09 133.398H29.09V113.358C29.09 112.331 28.255 111.495 27.227 111.495C26.199 111.495 25.364 112.331 25.364 113.358V133.398H23.364V113.358C23.364 111.228 25.097 109.495 27.227 109.495C29.357 109.495 31.09 111.228 31.09 113.358V133.398Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.09 133.398V124.809C30.09 123.228 31.372 121.946 32.953 121.946C34.534 121.946 35.816 123.228 35.816 124.809V133.398",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.815 134.398C35.263 134.398 34.815 133.951 34.815 133.398V124.809C34.815 123.782 33.98 122.947 32.952 122.947C31.924 122.947 31.089 123.782 31.089 124.809V133.398C31.089 133.951 30.641 134.398 30.089 134.398C29.537 134.398 29.089 133.951 29.089 133.398V124.809C29.089 122.679 30.822 120.947 32.952 120.947C35.082 120.947 36.815 122.679 36.815 124.809V133.398C36.815 133.951 36.368 134.398 35.815 134.398Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.816 133.398V126.718C35.816 125.137 37.098 123.855 38.679 123.855C40.26 123.855 41.542 125.137 41.542 126.718V133.398",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.541 134.398C40.989 134.398 40.541 133.951 40.541 133.398V126.718C40.541 125.691 39.706 124.855 38.678 124.855C37.65 124.855 36.815 125.691 36.815 126.718V133.398C36.815 133.951 36.367 134.398 35.815 134.398C35.263 134.398 34.815 133.951 34.815 133.398V126.718C34.815 124.588 36.548 122.855 38.678 122.855C40.808 122.855 42.541 124.588 42.541 126.718V133.398C42.541 133.951 42.093 134.398 41.541 134.398Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.541 133.398V128.627C41.541 127.046 42.823 125.764 44.404 125.764C45.985 125.764 47.267 127.046 47.267 128.627V137.216",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.267 138.216C46.715 138.216 46.267 137.769 46.267 137.216V128.627C46.267 127.6 45.432 126.764 44.404 126.764C43.376 126.764 42.541 127.6 42.541 128.627V133.398C42.541 133.951 42.093 134.398 41.541 134.398C40.989 134.398 40.541 133.951 40.541 133.398V128.627C40.541 126.497 42.274 124.764 44.404 124.764C46.534 124.764 48.267 126.497 48.267 128.627V137.216C48.267 137.769 47.819 138.216 47.267 138.216Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.765 79.8499H23.765V24.5869C23.765 24.0339 24.213 23.5869 24.765 23.5869H71.348V25.5869H25.765V79.8499Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69 24.5341C12.875 24.5341 15.652 26.2511 17.165 28.8061C17.324 29.0751 17.722 29.0341 17.811 28.7341C19.742 22.2591 25.739 17.5371 32.842 17.5371C41.506 17.5371 48.53 24.5611 48.53 33.2251H18.381H17.155H1C1 28.4251 4.891 24.5341 9.69 24.5341Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.529 34.2251H1C0.448 34.2251 0 33.7781 0 33.2251C0 27.8811 4.347 23.5351 9.69 23.5351C12.651 23.5351 15.453 24.9171 17.276 27.2111C19.735 20.8661 25.958 16.5381 32.841 16.5381C37.299 16.5381 41.489 18.2731 44.641 21.4261C47.793 24.5771 49.529 28.7691 49.528 33.2261C49.529 33.7771 49.082 34.2251 48.529 34.2251ZM2.065 32.2251H47.496C47.259 28.6781 45.765 25.3761 43.227 22.8391C40.453 20.0651 36.765 18.5371 32.841 18.5371C26.396 18.5371 20.609 22.8481 18.769 29.0201C18.615 29.5351 18.172 29.9101 17.641 29.9751C17.104 30.0431 16.58 29.7821 16.304 29.3161C14.924 26.9831 12.39 25.5341 9.69 25.5341C5.789 25.5341 2.556 28.4551 2.065 32.2251Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.801 6.10791V39.6719H79.301V49.6979L94.122 39.8899H133.135V6.10791H70.801Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.301 50.6969C79.138 50.6969 78.976 50.6579 78.828 50.5779C78.503 50.4039 78.301 50.0649 78.301 49.6969V40.6719H70.801C70.249 40.6719 69.801 40.2249 69.801 39.6719V6.10693C69.801 5.55393 70.249 5.10693 70.801 5.10693H133.134C133.686 5.10693 134.134 5.55393 134.134 6.10693V39.8899C134.134 40.4429 133.686 40.8899 133.134 40.8899H94.422L79.853 50.5319C79.687 50.6419 79.494 50.6969 79.301 50.6969ZM71.801 38.6719H79.301C79.853 38.6719 80.301 39.1189 80.301 39.6719V47.8359L93.57 39.0559C93.734 38.9479 93.925 38.8899 94.122 38.8899H132.135V7.10693H71.801V38.6719Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.653 1V34.565H162.837V44.59L148.016 34.783H110.084V1H199.653Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.836 45.591C162.643 45.591 162.451 45.535 162.284 45.425L147.715 35.782H110.083C109.531 35.782 109.083 35.335 109.083 34.782V1C109.083 0.447 109.531 0 110.083 0H199.652C200.204 0 200.652 0.447 200.652 1V34.564C200.652 35.117 200.204 35.564 199.652 35.564H163.836V44.59C163.836 44.958 163.634 45.297 163.309 45.471C163.162 45.552 162.999 45.591 162.836 45.591ZM111.083 33.782H148.016C148.212 33.782 148.404 33.84 148.568 33.948L161.837 42.729V34.564C161.837 34.011 162.285 33.564 162.837 33.564H198.653V2H111.084V33.782H111.083Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.968 24.1321H76.128C75.576 24.1321 75.128 23.6851 75.128 23.1321C75.128 22.5791 75.576 22.1321 76.128 22.1321H101.968C102.52 22.1321 102.968 22.5791 102.968 23.1321C102.968 23.6851 102.52 24.1321 101.968 24.1321Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.968 18.783H76.128C75.576 18.783 75.128 18.336 75.128 17.783C75.128 17.23 75.576 16.783 76.128 16.783H101.968C102.52 16.783 102.968 17.23 102.968 17.783C102.968 18.336 102.52 18.783 101.968 18.783Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.968 29.48H76.128C75.576 29.48 75.128 29.033 75.128 28.48C75.128 27.927 75.576 27.48 76.128 27.48H101.968C102.52 27.48 102.968 27.927 102.968 28.48C102.968 29.033 102.52 29.48 101.968 29.48Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.164 18.783H115.674C115.122 18.783 114.674 18.336 114.674 17.783C114.674 17.23 115.122 16.783 115.674 16.783H173.164C173.716 16.783 174.164 17.23 174.164 17.783C174.164 18.336 173.716 18.783 173.164 18.783Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.164 12.46H115.674C115.122 12.46 114.674 12.013 114.674 11.46C114.674 10.907 115.122 10.46 115.674 10.46H173.164C173.716 10.46 174.164 10.907 174.164 11.46C174.164 12.013 173.716 12.46 173.164 12.46Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.164 25.1069H115.674C115.122 25.1069 114.674 24.6599 114.674 24.1069C114.674 23.5539 115.122 23.1069 115.674 23.1069H173.164C173.716 23.1069 174.164 23.5539 174.164 24.1069C174.164 24.6599 173.716 25.1069 173.164 25.1069Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.49 19.5591C184.474 19.5591 185.272 18.7613 185.272 17.7771C185.272 16.7929 184.474 15.9951 183.49 15.9951C182.506 15.9951 181.708 16.7929 181.708 17.7771C181.708 18.7613 182.506 19.5591 183.49 19.5591Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.308 19.5591C192.292 19.5591 193.09 18.7613 193.09 17.7771C193.09 16.7929 192.292 15.9951 191.308 15.9951C190.324 15.9951 189.526 16.7929 189.526 17.7771C189.526 18.7613 190.324 19.5591 191.308 19.5591Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.684 98.4669H191.957C191.405 98.4669 190.957 98.0199 190.957 97.4669C190.957 96.9139 191.405 96.4669 191.957 96.4669H221.684V25.5869H199.653C199.101 25.5869 198.653 25.1399 198.653 24.5869C198.653 24.0339 199.101 23.5869 199.653 23.5869H222.684C223.236 23.5869 223.684 24.0339 223.684 24.5869V97.4669C223.684 98.0199 223.236 98.4669 222.684 98.4669Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.222 114.275H191.957C191.405 114.275 190.957 113.828 190.957 113.275C190.957 112.722 191.405 112.275 191.957 112.275H225.222C225.774 112.275 226.222 112.722 226.222 113.275C226.222 113.828 225.774 114.275 225.222 114.275Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.06 119.96H204.795C204.243 119.96 203.795 119.513 203.795 118.96C203.795 118.407 204.243 117.96 204.795 117.96H238.06C238.612 117.96 239.06 118.407 239.06 118.96C239.06 119.513 238.612 119.96 238.06 119.96Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.824 70.5159C211.048 70.5159 212.989 71.7149 214.045 73.4999C214.156 73.6879 214.434 73.6589 214.496 73.4499C215.845 68.9269 220.033 65.6289 224.995 65.6289C231.047 65.6289 235.953 70.5349 235.953 76.5869H214.894H214.037H202.754C202.754 73.2339 205.471 70.5159 208.824 70.5159Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.952 77.5859H202.754C202.202 77.5859 201.754 77.1389 201.754 76.5859C201.754 72.6879 204.925 69.5169 208.824 69.5169C210.814 69.5169 212.706 70.3719 214.032 71.8149C215.909 67.5229 220.231 64.6289 224.995 64.6289C231.588 64.6289 236.953 69.9929 236.953 76.5859C236.952 77.1389 236.504 77.5859 235.952 77.5859ZM203.853 75.5859H234.902C234.399 70.5639 230.148 66.6289 224.994 66.6289C220.624 66.6289 216.702 69.5519 215.453 73.7359C215.31 74.2109 214.902 74.5559 214.411 74.6159C213.917 74.6779 213.435 74.4369 213.182 74.0089C212.272 72.4719 210.601 71.5169 208.822 71.5169C206.371 71.5169 204.319 73.2679 203.853 75.5859ZM214.904 72.9889C214.904 72.9889 214.905 72.9899 214.904 72.9889C214.905 72.9899 214.904 72.9889 214.904 72.9889Z",
    fill: "#1B3858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.615 77.5859H202.754C202.202 77.5859 201.754 77.1389 201.754 76.5859C201.754 76.0329 202.202 75.5859 202.754 75.5859H242.615C243.167 75.5859 243.615 76.0329 243.615 76.5859C243.615 77.1389 243.167 77.5859 242.615 77.5859Z",
    fill: "#1B3858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 123.643,
    y1: 138.16,
    x2: 123.643,
    y2: 56.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0223,
    stopColor: "#0677F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2898,
    stopColor: "#4CA1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5307,
    stopColor: "#83C3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7368,
    stopColor: "#ABDBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C3EAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCEFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 62.9195,
    y1: 99.575,
    x2: 184.367,
    y2: 99.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0053,
    stopColor: "#CCEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 24.4218,
    y1: 123.691,
    x2: 24.4218,
    y2: 79.8493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0223,
    stopColor: "#0677F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2898,
    stopColor: "#4CA1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5307,
    stopColor: "#83C3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7368,
    stopColor: "#ABDBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C3EAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCEFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 24.4218,
    y1: 120.87,
    x2: 24.4218,
    y2: 83.3075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0053,
    stopColor: "#CCEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 123.643,
    y1: 113.28,
    x2: 123.643,
    y2: 87.1351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0223,
    stopColor: "#0677F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2898,
    stopColor: "#4CA1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5307,
    stopColor: "#83C3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7368,
    stopColor: "#ABDBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C3EAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCEFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 22.6988,
    y1: 98.3637,
    x2: 22.6988,
    y2: 86.7959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0223,
    stopColor: "#0677F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2898,
    stopColor: "#4CA1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5307,
    stopColor: "#83C3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7368,
    stopColor: "#ABDBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C3EAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCEFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 24.7648,
    y1: 33.2247,
    x2: 24.7648,
    y2: 17.5371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    stopColor: "#C6EDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2868,
    stopColor: "#B6E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4707,
    stopColor: "#9BE0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6704,
    stopColor: "#75D4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8803,
    stopColor: "#45C5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 101.968,
    y1: 49.6974,
    x2: 101.968,
    y2: 6.10751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2951,
    stopColor: "#FDBF34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#FBB52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7488,
    stopColor: "#F9A523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    stopColor: "#F68D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#F5870F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 154.868,
    y1: 44.5904,
    x2: 154.868,
    y2: 1.0004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2951,
    stopColor: "#FDBF34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#FBB52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7488,
    stopColor: "#F9A523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    stopColor: "#F68D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947,
    stopColor: "#F5870F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 219.353,
    y1: 76.5862,
    x2: 219.353,
    y2: 65.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCEFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1242,
    stopColor: "#C6EDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2868,
    stopColor: "#B6E8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4707,
    stopColor: "#9BE0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6704,
    stopColor: "#75D4FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8803,
    stopColor: "#45C5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26BCF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243.615,
    height: 153.484,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDadosCloud);
export default __webpack_public_path__ + "static/media/dados-cloud.79b00cac1b904ddc87b07e0f57214e39.svg";
export { ForwardRef as ReactComponent };